/* Theme-owned framing around real Loox widgets. Loox owns review data and controls. */
(()=>{
 function enhance(){
  if(!document.body.matches('.p2-voyage-page,.p2-site-reviews'))return;
  for(const video of document.querySelectorAll('loox-video-slider-widget')){
   const section=video.closest('.shopify-section');if(!section)continue;
   section.classList.add('p2-loox-video-stage');
   for(const [key,value]of Object.entries({'border-width':'2','border-radius':'16','border-color':'#033d5c','rating-icon-color':'#fbba13','play-button-color':'#fbba13','shadow-color':'#033d5c','text-color':'#ffffff'}))video.setAttribute(key,value);
   video.setAttribute('show-border','');video.removeAttribute('auto-play');video.removeAttribute('hide-arrows-mobile');
   if(!section.querySelector('.p2-loox-video-label')){const label=document.createElement('p');label.className='p2-loox-video-label';label.textContent='PRESS PLAY. MEET THE PEOPLE.';section.prepend(label)}
  }
  const wall=document.getElementById('looxReviews');const section=wall?.closest('.shopify-section');
  if(section){
   section.classList.add('p2-loox-wall');
   if(document.body.classList.contains('p2-voyage-page')&&!section.querySelector('.p2-loox-wall-heading')){
    const heading=document.createElement('div');heading.className='p2-loox-wall-heading';
    const title=document.createElement('h2');title.textContent='THE WHOLE GOOD WORD.';
    const intro=document.createElement('p');intro.textContent='Every review. In their own words.';
    heading.append(title,intro);section.prepend(heading);
   }
  }
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',enhance,{once:true});else enhance();
 window.addEventListener('w3-scripts-loaded',enhance);document.addEventListener('shopify:section:load',enhance);
})();
